import React from "react";

type BannerTitleProps = {
  title: string;
};

export function BannerTitle({ title }: BannerTitleProps) {
  return (
    <div className="BannerTitle">
      <div className="BannerTitle__title text-collins-banner font-bold">
        {title}
      </div>
    </div>
  );
}
